import { DB_APPLICATION_STATUS } from '#client/constants/application';

export const APPLICATION_STATUS_ALLOW_LIST = [
  DB_APPLICATION_STATUS.APPROVED,
  DB_APPLICATION_STATUS.AWAITING_DOCUMENTS,
  DB_APPLICATION_STATUS.DENIED,
  DB_APPLICATION_STATUS.PENDING,
  DB_APPLICATION_STATUS.PENDING_REVIEW
];

export const UNDER_REVIEW_LIST = [
  DB_APPLICATION_STATUS.PENDING_REVIEW,
  DB_APPLICATION_STATUS.PENDING,
  DB_APPLICATION_STATUS.DENIED
];
